import { FC } from "react";
import { DiscountItemType } from "src/Modules/Discounts/types";
import { Instructions } from "../components";
import GiftcardDetailsCardNew from "../components/GiftcardDetailsCard/GiftcardDetailsCard";
import GiftcardChips from "../components/GiftcardChips/GiftcardChips";
import GiftcardRangeSelector from "../components/GiftcardRangeSelector/GiftcardRangeSelector";
import GiftcardRedeemBar from "../components/GiftcardRedeemBar/GiftcardRedeemBar";
import { Divider } from "antd";

type Props = {
  data: DiscountItemType | undefined;
  imageUrl: string | undefined;
  itemCode?: string;
  items: DiscountItemType[];
  selectedItemIndex: number;
  setSelectedItemIndex: (i: number) => void;
  brandName?: string;
  rangeValue: number;
  onRangeChange: (value: number) => void;
};

const GiftcardDetailsWeb: FC<Props> = ({
  data,
  imageUrl,
  itemCode,
  items,
  selectedItemIndex,
  setSelectedItemIndex,
  brandName,
  rangeValue,
  onRangeChange,
}) => {
  return (
    <div className="flex w-full gap-10">
      <div className="flex-5 flex flex-col gap-6">
        <div className="rounded-xs flex flex-col gap-6 p-6 shadow-sm">
          <div className="flex flex-col gap-4">
            <GiftcardDetailsCardNew data={data} imageUrl={imageUrl} brandName={brandName} />
            <GiftcardChips items={items} selectedItemIndex={selectedItemIndex} onSelect={setSelectedItemIndex} />
            {data?.denominationType?.toLowerCase() === "range" && (
              <GiftcardRangeSelector item={data} rangeValue={rangeValue} onRangeChange={onRangeChange} />
            )}
          </div>
          <Divider className="m-0!"/>
          <div>
            <GiftcardRedeemBar data={data} imageUrl={imageUrl} itemCode={itemCode} />
          </div>
        </div>
      </div>
      <div className="flex-2 rounded-xs shadow-sm">
        <Instructions termsAndConditions={data?.termsAndConditions ?? ""} usageInstructions={data?.usageInstructions ?? ""} />
      </div>
    </div>
  );
};

export default GiftcardDetailsWeb;
